import React, { useState, useRef } from "react";
import './Category.scss';
// Category

import { Helmet } from "react-helmet";
import { useEffect } from "react";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
// Sliders
import { useLocation } from "react-router-dom";
import Faq from "react-faq-component";


export default function Category({ CitiesData, CategoryInfo, ZipCode, setZipCode, setUpdateApp }) {
    const url = new URL(window.location.href);
    const [Render, setRender] = useState();
    const [DateServiceType, setDateServiceType] = useState();
    const [scrollPosition, setScrollPosition] = useState(0);
    const [response, setResponse] = useState({});
    const [scrollButton, setScrollButton] = useState(false);
    const location = useLocation()
    const serviceParam = location.pathname.split('/')[2] || '';
    console.log(serviceParam);

    const containerRefReviews = useRef(null);
    const scrollRightReviews = () => {
        if (containerRefReviews.current && window.screen.width > 700) {
            containerRefReviews.current.scrollLeft += 330;
        } else {
            containerRefReviews.current.scrollLeft += 290;
        }
    };
    const containerRefProjects = useRef(null);
    const scrollRightProjects = () => {
        if (containerRefProjects.current && window.screen.width > 700) {
            containerRefProjects.current.scrollLeft += 380;
        } else {
            containerRefProjects.current.scrollLeft += 290;
        }
    };
    const containerRefscrollRightKeyWords = useRef(null);
    const scrollRightKeyWords = () => {
        if (containerRefscrollRightKeyWords.current && window.screen.width > 800) {
            containerRefscrollRightKeyWords.current.scrollLeft += 320;
        } else {
            containerRefscrollRightKeyWords.current.scrollLeft += 320;
        }
    };
    const containerRefscrollRightOffer = useRef(null);
    const scrollRightOffer = () => {
        if (containerRefscrollRightOffer.current && window.screen.width > 800) {
            containerRefscrollRightOffer.current.scrollLeft += 280;
        } else {
            containerRefscrollRightOffer.current.scrollLeft += 270;
        }
    };

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
        if (position > 1000) {
            setScrollButton(true)
        } else if (position < 1000) {
            setScrollButton(false)
        }
    };
    useEffect(() => {
        if (CategoryInfo && CategoryInfo.length > 0 && serviceParam) {
            const found = CategoryInfo.find(a => a.UrlCategory.toLowerCase() === serviceParam.toLowerCase());
            if (found) setDateServiceType(found);
        }
    }, [CategoryInfo, serviceParam]);

    useEffect(() => {
        (async () => {
            try {
                const aiKd = url.searchParams.get('kd');
                const aiService = serviceParam ? serviceParam.replace(/-/g, ' ') : '';
                const aiTopic = aiKd && aiKd !== 'null' ? aiKd : (aiService || 'home services');
                const searchKeyword = `I need from you 45 words about "${aiTopic}" how we "HandyBy" can help our clients to match with our verified pros and help them with that kind of service and always add that beside that kind of service we can help with other similar services, give me that as json file: title 3 words (include in the title words from the service, do not include the words "null" or "handyby") and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }


            window.addEventListener('scroll', handleScroll, { passive: true });
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        })()

    }, [null]);

    return (
        <div className="Category">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>HandyBy - Find Trusted {serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pros Near You</title>

                {/* <!-- META --> */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="%PUBLIC_URL%/1-airduct.jpg" />
                <meta property="og:url" content={`https://www.handyby.com/category/${url.pathname.split('/')[2]}`} />
                <meta property="description" content={`Get Matched With A Trusted Local ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pro For. Enter Your ZIP Code To Request Service Now—No Commitment Until You Approve The Price.`} />
                <meta property="og:description" content={`Get Matched With A Trusted Local ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pro For. Enter Your ZIP Code To Request Service Now—No Commitment Until You Approve The Price.`} />
                <meta property="og:title" content={`HandyBy - Top-Rated ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pros`} />
                <meta property="og:site_name" content={`HandyBy`} />
                <meta property="keywords" content={DateServiceType && DateServiceType.Services ? DateServiceType.Services.map(service => service.Title).join(', ') : ""} />
                <link rel="canonical" href={`https://www.handyby.com/category/${url.pathname.split('/')[2]}`} />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                {DateServiceType && (
                    <script type="application/ld+json">{JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "serviceType": DateServiceType.Category,
                        "name": DateServiceType.Category,
                        "url": `https://www.handyby.com/category/${url.pathname.split('/')[2]}`,
                        "provider": {
                            "@type": "Organization",
                            "name": "HandyBy",
                            "url": "https://www.handyby.com/",
                            "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "1800" }
                        },
                        "areaServed": { "@type": "Country", "name": "United States" }
                    })}</script>
                )}
                {DateServiceType && (
                    <script type="application/ld+json">{JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.handyby.com/" },
                            { "@type": "ListItem", "position": 2, "name": DateServiceType.Category, "item": `https://www.handyby.com/category/${url.pathname.split('/')[2]}` }
                        ]
                    })}</script>
                )}
            </Helmet>
            {/* CategoryNav */}
            <div className="CategoryNav">
                <div className="CategoryNavLocation">
                    <h3><img src={require(`../../Images/3d-house.png`)} /> Request Service in</h3>
                    <h4>{CitiesData && CitiesData.City ? CitiesData.City : "Local Pros"} <img src={require(`../../Images/ArrowDown.png`)} /></h4>
                </div>
                <div className="CategoryNavShape">
                    <div className="CategoryNavShapeInside">
                        <h1>HandyBy /</h1>
                        <h1>Category /</h1>
                        <h1>{url.pathname.split('/')[2] ? DateServiceType ? DateServiceType.Category : "" : 'New Project'}</h1>
                    </div>
                </div>
            </div>
            {/* HomePageTopBanner */}
            <div className="HomePageTopBanner">
                <img src={DateServiceType ? DateServiceType.Image : ""} />
                <div className="HomePageTopBannerText">
                    <h1>Get Matched With Top <span>{DateServiceType ? DateServiceType.Category : ""}</span> Pros Near You</h1>
                    <h2>Enter ZIP and We'll Match You With A Trusted <span>{DateServiceType ? DateServiceType.Category : ""}</span> Pro.</h2>
                    <div className="HomePageTopBannerTextInput">
                        <div className="HomePageTopBannerTextInputImg">
                            <img src={require(`../../Images/search1.png`)} />
                        </div>
                        <input
                            type="number"
                            inputMode="numeric"
                            placeholder="ZIP Code" defaultValue={ZipCode && ZipCode.length ? ZipCode : ""} value={ZipCode && ZipCode.length ? ZipCode : ""} onChange={(a) => {
                                setRender(a => !a)
                                setZipCode(a.target.value)
                                setUpdateApp(a => !a)
                                setRender(a => !a)
                            }} />
                    </div>
                    <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${url.pathname.split('/')[2]}${url.search ? "&" + url.search.slice(1) : ""}`} >Find Pro</a>
                </div>
                <img src={require(`../../Images/TrustPilot.png`)} />
            </div>
            {/* CategoryMatch */}
            <div className="CategoryMatch">
                <h1>How HandyBy Works</h1>
                <div className="CategoryMatchBorder"></div>
                <div className="CategoryMatchList">
                    <div className="CategoryMatchBox">
                        <div className="CategoryMatchBoxImg">
                            <h4>+</h4>
                        </div>
                        <div className="CategoryMatchBoxTxt">
                            <h2>Tell Us What You Need Done</h2>
                            <p>Share a few quick details about your {DateServiceType ? DateServiceType.Category : ""} project.</p>
                        </div>
                    </div>
                    <div className="CategoryMatchBox">
                        <div className="CategoryMatchBoxImg">
                            <img src={require(`../../Images/tools.png`)} alt="Match Pro" />
                        </div>
                        <div className="CategoryMatchBoxTxt">
                            <h2>We’ll Match You With A Pro</h2>
                            <p>We connect you with a verified local pro ready to help.</p>
                        </div>
                    </div>
                    <div className="CategoryMatchBox">
                        <div className="CategoryMatchBoxImg">
                            <img src={require(`../../Images/house.png`)} alt="Pro On The Way" />
                        </div>
                        <div className="CategoryMatchBoxTxt">
                            <h2>Your Pro Is On The Way</h2>
                            <p>They’ll arrive ready to work, no pricing until you both agree.</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* CategoryTrusted */}
            <div className="CategoryTrusted">
                <h1>Trusted By Homeowners</h1>
                <div className="CategoryTrustedList">

                    <div className="CategoryTrustedBox">
                        <h2>4.9</h2>
                        <span>
                            <img src={require(`../../Images/star.png`)} alt="Customer Rating" />
                            <h3>Average Customer Rating</h3>
                        </span>
                    </div>

                    <div className="CategoryTrustedBox">
                        <h2>4,434</h2>
                        <span>
                            <img src={require(`../../Images/verifed.png`)} alt="Verified Reviews" />
                            <h3>Verified {DateServiceType ? DateServiceType.Category : ""} Service Reviews</h3>
                        </span>
                    </div>

                    <div className="CategoryTrustedBox">
                        <h2>210</h2>
                        <span>
                            <img src={require(`../../Images/3d-house.png`)} alt="Approved Pros" />
                            <h3>Approved {DateServiceType ? DateServiceType.Category : ""} Pros On HandyBy</h3>
                        </span>
                    </div>

                </div>
            </div>
            {/* CategoryReviews */}
            <div className="CategoryReviews">
                <div className="CategoryReviewsTitle">
                    <h1>Verified Reviews for <span>{DateServiceType ? DateServiceType.Category : ""}</span> pros <span>{CitiesData && CitiesData.City ? "in " + CitiesData.City : "Near You"}</span></h1>
                    <h2>The HandyBy Rating For {DateServiceType ? DateServiceType.Category : ""} Pros {CitiesData && CitiesData.City ? "in " + CitiesData.City : "Near You"} Is Based On Verified Reviews From Homeowners Who Have Hired These Pros For Their {DateServiceType ? DateServiceType.Category : ""} Project And Repair Needs.</h2>
                </div>
                <div className="CategoryReviewsList" ref={containerRefReviews}>
                    {DateServiceType ? DateServiceType.Reviews.map((A, Index) => {
                        return <div key={Index} className="CategoryReviewsListBox">
                            <div className="CategoryReviewsListBoxTop">
                                <h1>{A.name}</h1>
                                <span>
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                </span>
                                <h2>Reviewed in {A.date}</h2>
                                <h3>{A.review.slice(0, 165) + '...'}</h3>
                                <h6>Verified Review</h6>
                            </div>
                            <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${url.pathname.split('/')[2]}${url.search ? "&" + url.search.slice(1) : ""}`}>Request Service</a>
                        </div>
                    }) : <h2>Loading...</h2>}
                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightReviews}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
                <div className="CategoryReviewsConfirmed">
                    <img src={require(`../../Images/n-success.png`)} />
                    <h2>Companies on HandyBy can’t offer incentives or pay to hide any reviews.</h2>
                </div>
            </div>
            {/* ServicesOurTop3Offers */}
            <div className="ServicesTop3Offer" id="Services">
                <h2>Our Top 5 Contractors {DateServiceType && DateServiceType.Services ? DateServiceType.Category : ""} Services</h2>
                <h3>These are our Top 5 {DateServiceType && DateServiceType.Services ? DateServiceType.Category : ""} Contractors and the services they offer—trusted experts chosen for their quality, reliability, and outstanding customer satisfaction.</h3>
                <div className="ServicesTop3OfferList" ref={containerRefscrollRightOffer}>
                    {DateServiceType && DateServiceType.Services ? DateServiceType.Services.map((A, index) => (
                        <div className="ServicesTop3OfferBox" key={index}>
                            <img src={A.Images} alt={A.Title} />
                            <h1>{A.Title}</h1>
                            <h2>{A.Description}</h2>
                        </div>
                    )) : <h1>Loading...</h1>}
                </div>
                <div className="HomePageOfferSCrollRight" onClick={scrollRightOffer}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div>
            {/* CategoryAI */}
            <div className="CategoryAI">
                <img src={require(`../../Images/3d-house.png`)} />
                <div className="CategoryAIText">
                    <h4>{response.title}</h4>
                    <h3>{response.body}</h3>
                </div>
            </div>

            {/* CategoryByServices */}
            <div className="CategoryByServices">
                <h2>Top 5 Professional {DateServiceType?.Category} Services</h2>
                <h3>These top-rated contractors specialize in {DateServiceType?.Category}—handpicked for their expertise, customer satisfaction, and service quality. Explore the key services they offer below.</h3>

                <div className="CategoryByServicesList" ref={containerRefscrollRightKeyWords}>
                    {DateServiceType && DateServiceType.ServicesByCategory ? DateServiceType.ServicesByCategory.map((A, index) => (
                        <div className="CategoryByServicesListItem" key={index}>
                            <h4><img src={require('../../Images/technician.png')} alt="" />{A.category}</h4>
                            <div className="CategoryByServicesListItemKeyWords">

                                {A.services.map((keyword, keywordIndex) => {
                                    const capitalized = keyword.charAt(0).toUpperCase() + keyword.slice(1);
                                    return <h5 key={keywordIndex} >• {capitalized}</h5>;
                                })}
                            </div>
                        </div>
                    )) : null}

                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightKeyWords}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div>
            {/* CategoryProjects */}
            {DateServiceType && DateServiceType.Projects && DateServiceType.Projects.length > 0 ?
                <div className="CategoryProjects">
                    <h1>Recent projects done by HandyBy's {DateServiceType ? DateServiceType.Category : ""} pros</h1>
                    <div className="CategoryProjectsList" ref={containerRefProjects}>
                        {DateServiceType ? DateServiceType.Projects.map((A, Index) => {
                            return <div key={Index} className="CategoryProjectsBox">
                                <div className="CategoryProjectsBoxText">
                                    <h2>{A.Title}</h2>
                                    <h3>{A.Description}</h3>
                                </div>
                                <img src={A.Images} />
                            </div>
                        }) : <h2>Loading...</h2>}
                    </div>
                    <div className="HomePageServicesListSCrollRight" onClick={scrollRightProjects}>
                        <img src={require(`../../Images/next.png`)} />
                    </div>
                    {/* <h4>Price shown is the national median price of minimum job size for Angi's pre-priced offering. Actual pricing may vary.</h4> */}
                </div>
                : null}

            {/* CategoryHowMatchWork */}
            <div className="CategoryHowMatchWork">
                <h1>How HandyBy Work?</h1>
                <div className="CategoryHowMatchWorkList">
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox1">
                            <div className="CategoryHowMatchWorkBoxBox1Back">
                                <h2>Create a Project</h2>
                                <h3>Find a qualified pro for the exact service you’re looking for :)</h3>
                                <h4>Roofing contractor near me |</h4>
                            </div>
                        </div>
                        <h2>Tell Us What You Need</h2>
                        <h3>Submit a quick project request with the service you’re looking for.</h3>
                    </div>
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox2">
                            <h4>You have new project</h4>
                            <img className="" src={require(`../../Images/howitwork2.png`)} />
                        </div>
                        <h2>Get Matched with a HandyBy Pro</h2>
                        <h3>We connect you with a qualified, local contractor who can get it done.</h3>
                    </div>
                    <div className="CategoryHowMatchWorkBox">
                        <div className="CategoryHowMatchWorkBoxBox3">
                            <img className="" src={require(`../../Images/contractorProfile.jpeg`)} />
                            <h4>🚘 &nbsp; A HandyBy Pro Is On The Way...</h4>
                        </div>
                        <h2>Post your task</h2>
                        <h3>Your HandyBy Pro shows up ready to work. No surprises work, only starts once you both agree on the price.

                        </h3>
                    </div>
                </div>
                <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${url.pathname.split('/')[2]}${url.search ? "&" + url.search.slice(1) : ""}`}>Handy Me Now :)</a>
            </div>
            {/* CategoryFaq */}
            <div className="CategoryFaq">
                <h1>{DateServiceType ? DateServiceType.Category : ""} services FAQs</h1>
                <div className="MainBanner4FaqMore">
                    {DateServiceType && DateServiceType.faq ?
                        <Faq
                            data={DateServiceType.faq.data}
                            styles={DateServiceType.faq.styles}
                            config={DateServiceType.faq.config}
                        />
                        :
                        null}
                </div>
            </div>
            {/* GetFund Button */}
            {scrollButton ?
                <div className="StartMatchingButton">
                    <a href={`/request-service?${ZipCode ? `zipcode=${ZipCode}&` : ''}service=${url.pathname.split('/')[2]}${url.search ? "&" + url.search.slice(1) : ""}`} onClick={() => { window.scrollTo(0, 0) }}>Find Pro</a>
                    <h2>Find A Pro For Your {DateServiceType ? DateServiceType.Category : ""} Project.</h2>
                </div>
                : null}

            {!url.searchParams.get('spg') ?
                <NavigatorPath />
                : null}
        </div >
    )
}

